import React from "react";
import SiteContent from "../components/site-items/SiteContent/SiteContent";
import Navbar from "../parts/Navbar/Navbar";
import Footer from "../parts/Footer/Footer";
import Intro from "../sections/Intro/Intro";
import Menu from "../components/buttons/Menu/Menu";
import About from "../sections/About/About";
import News from "../sections/News/News";
import FacebookGroup from "../sections/FacebookGroup/FacebookGroup";
import Matches from "../sections/Matches/Matches";
import Info from "../sections/Info/Info";
import Statistics from "../sections/Statistics/Statistics";
import PageWrapper from "../components/page-items/PageWrapper/PageWrapper";

const Main = () => {
    return (
        <SiteContent>
            <Navbar/>
            <PageWrapper>
                <Intro/>
                <About/>
                <News/>
                <FacebookGroup/>
                <Matches/>
                <Statistics/>
                <Info/>
                <Menu/>
            </PageWrapper>
            <Footer/>
        </SiteContent>
    );
};

export default Main;
